module.exports = __webpack_public_path__ + "img/douyin.76bc1c53.png";